import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaApparatoLocomotoreEditComponent.vue?vue&type=template&id=3c76be2d"
import script from "./RsaSchedaRelazioneSanitariaApparatoLocomotoreEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaApparatoLocomotoreEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports